// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_bg-0";
export var optionCard = "_bg-1";